export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'falv-fagui',
    name: '法律法规',
    description: '涵盖国内外与成人内容相关的法律法规解读，帮助用户了解十八禁内容的法律边界与合规要求。',
    icon: 'ri-scales-3-line',
    articleCount: 12,
  },
  {
    slug: 'neirong-fenji',
    name: '内容分级',
    description: '介绍不同国家与平台的成人内容分级体系，解读R18、NC-17、X级等分级标准及其适用范围。',
    icon: 'ri-filter-3-line',
    articleCount: 10,
  },
  {
    slug: 'anquan-zhiyin',
    name: '安全指引',
    description: '提供成年用户安全浏览的实用建议，包括隐私保护、网络安全、心理健康等维度的指导。',
    icon: 'ri-shield-check-line',
    articleCount: 8,
  },
  {
    slug: 'pingtai-hegui',
    name: '平台合规',
    description: '面向内容平台运营者，讲解成人内容平台的合规要求、审核机制与行业最佳实践。',
    icon: 'ri-building-2-line',
    articleCount: 9,
  },
  {
    slug: 'nianling-yanzheng',
    name: '年龄验证',
    description: '探讨各类年龄验证技术的原理与实施，包括身份认证、生物识别、第三方验证等方案。',
    icon: 'ri-fingerprint-line',
    articleCount: 7,
  },
];